import { createStyles } from "@mantine/core";

export default createStyles ( theme => {

	return {
		appBar: {
			// background   : theme.other.colors.background.tertiary,
			borderTop    : "none !important",
			borderRight  : "none !important",
			borderLeft   : "none !important",
			// borderBottom : `1px solid ${ theme.other.colors.border.primary }`,
			boxShadow    : "none",
			zIndex       : "100 !important",
			borderRadius : "unset !important",
			width        : "100%",
			background   : theme.other.colors.background.primary,
			position     : "sticky",
			border       : theme.other.darkMode ? "unset" : "1px solid rgb(231, 231, 231)"
		},
		tabFlexContainer: {
			justifyContent : "space-around",
			width          : "100%",
			display        : "flex"

		},
		tabRoot: {
			width      : "100%",
			// padding    : "1.75rem 2rem",
			background : theme.other.darkMode ? `${ theme.other.paletteNew.darkModeInclinedBlack1 } !important` : "inherit"

		},
		textIconContainer: {
			display       : "flex",
			alignItems    : "center",
			fontWeight    : "500",
			textTransform : "none"
		},
		svgIcon: {
			...theme.other.svgIcons.size25,
			marginRight: "0.5rem"
		},
		activeTabText: {
			fontWeight : "500 !important",
			color      : `${ theme.other.paletteNew.primaryDarkBlue } !important`
		},
		tabText: {
			fontWeight : "500 !important",
			fontSize   : "1.7rem",
			color      : theme.other.colors.text.secondary
		},
		mantineTab: {
			flex         : "1",
			padding      : "1.5rem",
			borderBottom : "0.25rem solid transparent"
		}
	};
} );
